/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import * as z from "zod/v4-mini";
import { remap as remap$ } from "../../lib/primitives.js";
import {
  CreateMcpEndpointForm,
  CreateMcpEndpointForm$Outbound,
  CreateMcpEndpointForm$outboundSchema,
} from "../components/createmcpendpointform.js";

export type CreateMcpEndpointSecurityOption1 = {
  projectSlugHeaderGramProject: string;
  sessionHeaderGramSession: string;
};

export type CreateMcpEndpointSecurityOption2 = {
  apikeyHeaderGramKey: string;
  projectSlugHeaderGramProject: string;
};

export type CreateMcpEndpointSecurity = {
  option1?: CreateMcpEndpointSecurityOption1 | undefined;
  option2?: CreateMcpEndpointSecurityOption2 | undefined;
};

export type CreateMcpEndpointRequest = {
  /**
   * Session header
   */
  gramSession?: string | undefined;
  /**
   * API Key header
   */
  gramKey?: string | undefined;
  /**
   * project header
   */
  gramProject?: string | undefined;
  createMcpEndpointForm: CreateMcpEndpointForm;
};

/** @internal */
export type CreateMcpEndpointSecurityOption1$Outbound = {
  "project_slug_header_Gram-Project": string;
  "session_header_Gram-Session": string;
};

/** @internal */
export const CreateMcpEndpointSecurityOption1$outboundSchema: z.ZodMiniType<
  CreateMcpEndpointSecurityOption1$Outbound,
  CreateMcpEndpointSecurityOption1
> = z.pipe(
  z.object({
    projectSlugHeaderGramProject: z.string(),
    sessionHeaderGramSession: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
      sessionHeaderGramSession: "session_header_Gram-Session",
    });
  }),
);

export function createMcpEndpointSecurityOption1ToJSON(
  createMcpEndpointSecurityOption1: CreateMcpEndpointSecurityOption1,
): string {
  return JSON.stringify(
    CreateMcpEndpointSecurityOption1$outboundSchema.parse(
      createMcpEndpointSecurityOption1,
    ),
  );
}

/** @internal */
export type CreateMcpEndpointSecurityOption2$Outbound = {
  "apikey_header_Gram-Key": string;
  "project_slug_header_Gram-Project": string;
};

/** @internal */
export const CreateMcpEndpointSecurityOption2$outboundSchema: z.ZodMiniType<
  CreateMcpEndpointSecurityOption2$Outbound,
  CreateMcpEndpointSecurityOption2
> = z.pipe(
  z.object({
    apikeyHeaderGramKey: z.string(),
    projectSlugHeaderGramProject: z.string(),
  }),
  z.transform((v) => {
    return remap$(v, {
      apikeyHeaderGramKey: "apikey_header_Gram-Key",
      projectSlugHeaderGramProject: "project_slug_header_Gram-Project",
    });
  }),
);

export function createMcpEndpointSecurityOption2ToJSON(
  createMcpEndpointSecurityOption2: CreateMcpEndpointSecurityOption2,
): string {
  return JSON.stringify(
    CreateMcpEndpointSecurityOption2$outboundSchema.parse(
      createMcpEndpointSecurityOption2,
    ),
  );
}

/** @internal */
export type CreateMcpEndpointSecurity$Outbound = {
  Option1?: CreateMcpEndpointSecurityOption1$Outbound | undefined;
  Option2?: CreateMcpEndpointSecurityOption2$Outbound | undefined;
};

/** @internal */
export const CreateMcpEndpointSecurity$outboundSchema: z.ZodMiniType<
  CreateMcpEndpointSecurity$Outbound,
  CreateMcpEndpointSecurity
> = z.pipe(
  z.object({
    option1: z.optional(
      z.lazy(() => CreateMcpEndpointSecurityOption1$outboundSchema),
    ),
    option2: z.optional(
      z.lazy(() => CreateMcpEndpointSecurityOption2$outboundSchema),
    ),
  }),
  z.transform((v) => {
    return remap$(v, {
      option1: "Option1",
      option2: "Option2",
    });
  }),
);

export function createMcpEndpointSecurityToJSON(
  createMcpEndpointSecurity: CreateMcpEndpointSecurity,
): string {
  return JSON.stringify(
    CreateMcpEndpointSecurity$outboundSchema.parse(createMcpEndpointSecurity),
  );
}

/** @internal */
export type CreateMcpEndpointRequest$Outbound = {
  "Gram-Session"?: string | undefined;
  "Gram-Key"?: string | undefined;
  "Gram-Project"?: string | undefined;
  CreateMcpEndpointForm: CreateMcpEndpointForm$Outbound;
};

/** @internal */
export const CreateMcpEndpointRequest$outboundSchema: z.ZodMiniType<
  CreateMcpEndpointRequest$Outbound,
  CreateMcpEndpointRequest
> = z.pipe(
  z.object({
    gramSession: z.optional(z.string()),
    gramKey: z.optional(z.string()),
    gramProject: z.optional(z.string()),
    createMcpEndpointForm: CreateMcpEndpointForm$outboundSchema,
  }),
  z.transform((v) => {
    return remap$(v, {
      gramSession: "Gram-Session",
      gramKey: "Gram-Key",
      gramProject: "Gram-Project",
      createMcpEndpointForm: "CreateMcpEndpointForm",
    });
  }),
);

export function createMcpEndpointRequestToJSON(
  createMcpEndpointRequest: CreateMcpEndpointRequest,
): string {
  return JSON.stringify(
    CreateMcpEndpointRequest$outboundSchema.parse(createMcpEndpointRequest),
  );
}
